import type { Slice } from "@reduxjs/toolkit"
import { combineSlices, configureStore } from "@reduxjs/toolkit"
import {
  // eslint-disable-next-line @typescript-eslint/no-restricted-imports
  useDispatch as useDispatchBase,
  // eslint-disable-next-line @typescript-eslint/no-restricted-imports
  useSelector as useSelectorBase,
} from "react-redux"
import { setupListeners } from "@reduxjs/toolkit/query/react"
import baseApi from "./baseApi"
import authSlice from "./auth/slice"

export const rootReducer = combineSlices(baseApi, authSlice)

// Not checking immutability or serializability for anything by RTK Query
const ignoredPaths = ["api"]

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: { ignoredPaths },
      serializableCheck: { ignoredPaths },
    }).concat(baseApi.middleware),
})

setupListeners(store.dispatch)

type AppDispatch = typeof store.dispatch
export const useDispatch = useDispatchBase.withTypes<AppDispatch>()

export type RootState = ReturnType<typeof store.getState>
export const useSelector = useSelectorBase.withTypes<RootState>()

export const injectSlice = <TSlice extends Slice>(slice: TSlice) => {
  rootReducer.inject(slice)

  // dummy dispatch to init slice
  store.dispatch({ type: `@@SLICE/${slice.name}` })

  return useSelectorBase.withTypes<
    RootState & { [TPath in TSlice["name"]]: ReturnType<TSlice["reducer"]> }
  >()
}

export default store
